/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

/**
 * Returns the appropriate fitting parts URL based on ACES feature flag
 * @param url - The original fitting parts URL
 * @param acesEnabled - Whether ACES is enabled
 * @returns The final URL to use for fitting parts navigation
 */
export const getFittingPartsURL = (url: string, acesEnabled: boolean): string => {
  if (acesEnabled) {
    return url;
  }
  return url.split('/p/')[0];
};
